import { BaseHostMapComplete } from "../../lib";
const BaseProdHost = BaseHostMapComplete("higochat.net");
const ProdHost = [
  // 最基本的
  BaseProdHost,
  // 动态域名新增的
  BaseHostMapComplete("higotalk.com"),
  // 不用来使用，只是为了解决历史遗留问题（后端下发的图片都是mehiya.com）
  BaseHostMapComplete("mehiya.com")
];
export {
  BaseProdHost,
  ProdHost
};
